export * from '@primeuix/themes/aura/timeline';
export { default } from '@primeuix/themes/aura/timeline';
